"use strict";

import { Auth0Client } from '@auth0/auth0-spa-js';
import { AUTH_CLIENT_ID, AUTH_DOMAIN, AUTH_SCOPE } from '@autoguru/global-configs';
let clientCache = null;
const getClientCache = () => process.__browser__ ? window['clientCache'] : clientCache;
const setClientCache = client => {
  if (process.__browser__) window['clientCache'] = client;else clientCache = client;
};
export const createClient = options => {
  var _options$cacheLocatio, _options$audience;
  const client = getClientCache() || new Auth0Client({
    clientId: AUTH_CLIENT_ID !== null && AUTH_CLIENT_ID !== void 0 ? AUTH_CLIENT_ID : '',
    domain: AUTH_DOMAIN !== null && AUTH_DOMAIN !== void 0 ? AUTH_DOMAIN : '',
    cacheLocation: (_options$cacheLocatio = options === null || options === void 0 ? void 0 : options.cacheLocation) !== null && _options$cacheLocatio !== void 0 ? _options$cacheLocatio : 'localstorage',
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    authorizationParams: {
      audience: (_options$audience = options === null || options === void 0 ? void 0 : options.audience) !== null && _options$audience !== void 0 ? _options$audience : 'https://gateway.autoguru.com.au',
      redirect_uri: '',
      scope: AUTH_SCOPE !== null && AUTH_SCOPE !== void 0 ? AUTH_SCOPE : 'openid profile email'
    }
  });
  setClientCache(client);
  return client;
};
export const getCurrentClient = getClientCache;
export const hasCurrentClient = () => getClientCache() !== null;
export const isAuthenticated = () => {
  var _getCurrentClient;
  return ((_getCurrentClient = getCurrentClient()) === null || _getCurrentClient === void 0 ? void 0 : _getCurrentClient.isAuthenticated()) || false;
};
export const getAccessToken = () => {
  var _getCurrentClient2;
  return ((_getCurrentClient2 = getCurrentClient()) === null || _getCurrentClient2 === void 0 ? void 0 : _getCurrentClient2.getTokenSilently()) || null;
};